import { render } from "./SeedJung_CounselorList.vue?vue&type=template&id=7fb5f15a&scoped=true"
import script from "./SeedJung_CounselorList.vue?vue&type=script&lang=js"
export * from "./SeedJung_CounselorList.vue?vue&type=script&lang=js"

import "./SeedJung_CounselorList.vue?vue&type=style&index=0&id=7fb5f15a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb5f15a"]])

export default __exports__